<template>
  <v-container
    id="customers"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-phone-ring"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Support
        </div>
      </template>

      <div
        class="mt-7"
        v-html="info"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    data: () => ({

    }),
    computed: {
      info () {
        return this.$store.state.general.supportInfo
      },
    },
    created: async function () {
      if (!this.$store.state.general.supportInfo) {
        await this.$store.dispatch('RefreshSupportPage')
      }
    },
    methods: {
    },
  }
</script>
